import { FC, ReactElement } from "react";
import { Box, Dialog, IconButton, Stack, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

import { ContainedButton } from "@/common";
import { logout_red_icon } from "@/constants";
interface LogoutModalProps extends StandardModalProps {
  maxWidth: "xs" | "sm" | "md" | "lg" | "xl";
  noPadding?: boolean;
  onConfirm: () => void;
}

const LogoutConfirmModal: FC<LogoutModalProps> = ({
  open,
  onClose,
  noPadding,
  maxWidth,
  onConfirm,
}): ReactElement => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      sx={{
        backgroundColor: "rgba(30, 30, 30, 0.34)",
        ".MuiDialog-paper": {
          padding: noPadding ? "0rem" : "1.7rem",
          "::-webkit-scrollbar": { width: "0" },
        },
        div: {
          borderRadius: "16px",
        },
      }}
    >
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Box
          sx={{
            backgroundColor: "#FFD8D6",
            width: "48px",
            height: "48px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50% !important",
          }}
        >
          <img src={logout_red_icon} width={20} />
        </Box>
        <IconButton onClick={onClose}>
          <CloseIcon fontSize="large" />
        </IconButton>
      </Box>
      <Box my={2}>
        <Typography fontSize={20} noWrap fontWeight={500}>
          Logout
        </Typography>
        <Typography fontSize={15} color={"#8C8E9C"} fontWeight={400}>
          Are you sure you want to logout? If logged out, you will not be able
          to receive notificatiion.
        </Typography>
      </Box>
      <Stack spacing={2} direction={"row"} pt={3}>
        <ContainedButton
          title="Close"
          size="large"
          onClick={onClose}
          sx={{
            border: "1px solid #E6E6E9",
            flex: "1",
            color: "black",
            boxShadow:
              "0px 1px 3px 0px rgba(16, 24, 32, 0.05), 0px 23px 44px 0px rgba(16, 24, 32, 0.05)",
          }}
          variant="white-contained"
        />
        <ContainedButton
          size="large"
          title={"Logout"}
          color="error"
          onClick={onConfirm}
          sx={{ flex: 1, color: "#FFFFFF" }}
        />
      </Stack>
    </Dialog>
  );
};

export default LogoutConfirmModal;
